module.exports = __webpack_public_path__ + "img/post-icon.f05c040c.svg";